import { MATERIAL_UNLOCK_LEVEL, translate, type Lang } from '@somnhold/content';

const KEY = 'somnhold.lang';
const detect = (): Lang => {
  try {
    const saved = localStorage.getItem(KEY);
    if (saved === 'es' || saved === 'en') return saved;
  } catch {
    /* storage blocked */
  }
  return navigator.language?.toLowerCase().startsWith('es') ? 'es' : 'en';
};

let lang: Lang = detect();
const listeners = new Set<() => void>();

export const getLang = (): Lang => lang;
export const setLang = (l: Lang): void => {
  lang = l;
  try {
    localStorage.setItem(KEY, l);
  } catch {
    /* storage blocked */
  }
  document.documentElement.lang = l;
  for (const f of listeners) f();
};
export const onLang = (f: () => void): (() => void) => {
  listeners.add(f);
  return () => listeners.delete(f);
};
/** Every visible string goes through here (CLAUDE.md). */
export const t = (key: string, vars?: Record<string, string | number>): string => translate(lang, key, vars);
/** The numbers a refusal's words name: shown from many places, they all go through {@link reasonText} so none prints a bare «{n}». */
const REASON_VARS: Record<string, Record<string, number>> = { stoneLocked: { n: MATERIAL_UNLOCK_LEVEL[2] }, ironLocked: { n: MATERIAL_UNLOCK_LEVEL[3] } };
/** Why the sim refused a command, in words; undefined when that reason has none. */
export const reasonText = (r: string): string | undefined => {
  const s = t(`reason.${r}`, REASON_VARS[r]);
  return s === `reason.${r}` ? undefined : s;
};
document.documentElement.lang = lang;

/** Names as one phrase in the current language: «Ana, Bo y vos». */
export const listNames = (xs: string[]): string => new Intl.ListFormat(getLang(), { style: 'long', type: 'conjunction' }).format(xs);
